import { CatalogItemType } from '@/lib/shared-types';

/**
 * §16 / S-09 — the product types a kitchen station can prepare.
 *
 * A station means "a ticket prints here and someone makes this". A timed
 * resource (an hour of PS5), a package and an experience are SOLD, not
 * prepared, so routing one to a station puts a ticket on the kitchen board that
 * nobody can ever complete. The send path already skips any line with no
 * station; keeping the field empty for these types is what makes that skip
 * deliberate rather than accidental.
 *
 * This lived in `dashboard/src/Pages/Catalog/lib.ts` and was therefore a rule
 * only the item form obeyed. Every other way of setting a station — the bulk
 * edit, the import, and now the kitchen's own "fix this product" action — could
 * put a station on a PlayStation hour and nothing would refuse it. It is here
 * so the API and every client read the same list.
 */
export const PREPARABLE_TYPES: readonly CatalogItemType[] = [
  CatalogItemType.PRODUCT,
  CatalogItemType.MEAL_COMBO,
  CatalogItemType.ADD_ON,
  CatalogItemType.SERVICE,
];

export const isPreparable = (type: CatalogItemType): boolean => PREPARABLE_TYPES.includes(type);
